export default __webpack_public_path__ + "static/media/okok.bc35f1e6.jpg";